import React from 'react'
import PropTypes from 'prop-types'

// Model
import Ecwt from 'models/Ecwt'

// Components
import Text from 'ui/Text'

export const ColumnCreatedAtMobile = ({ row }) => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f8ff',
        borderTopLeftRadius: '8px',
        borderBottomLeftRadius: '8px',
      }}
    >
      <Text
        size={12}
        color="#000000"
        nowrap
        paddingTop={16}
        paddingBottom={7}
        paddingRight={5}
        paddingLeft={5}
      >
        Date added
      </Text>
      <div
        style={{
          width: '54px',
          height: '54px',
          borderRadius: '50%',
          backgroundColor: '#ecf0fa',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          lineHeight: '17px',
        }}
      >
        <Text bold size={10} color="#020202">
          {row.createdAtMonth}
        </Text>
        <Text bold size={26} color="#020202">
          {row.createdAtDay}
        </Text>
      </div>
      <Text size={10} paddingTop={10} paddingBottom={14}>
        {row.createdAtYear}
      </Text>
    </div>
  )
}

ColumnCreatedAtMobile.propTypes = {
  row: PropTypes.instanceOf(Ecwt),
}

ColumnCreatedAtMobile.defaultProps = {
  row: new Ecwt(),
}

export default ColumnCreatedAtMobile
